import { UserContext } from '@bimdata/definitions/types';
import store from '@/state/store';
import api from '@/api/api';
import { handleError } from '@/actions/common';
import { jwtDecode } from 'jwt-decode';

export default function (): void {
  const session = api.getSession();
  if (!!session) {
    try {
      let profile = store.getState().authentication.profile;
      if (profile && profile.id !== (jwtDecode(session.access) as UserContext).id) {
        window.location.reload();
      }
    } catch (error) {
      handleError(error);
    }
  }
};